import styled from "styled-components";

export const Container = styled.div`
  padding: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
  transition: color 0.2s ease;

  &:hover {
    color: #374151;
  }
`;

export const StockInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const StockSymbol = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px 0;
  line-height: 1.2;
`;

export const StockName = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #6b7280;
  margin: 0;
  line-height: 1.3;
`;

export const StockPrice = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
  text-align: right;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const PriceChange = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ isPositive }) => (isPositive ? "#059669" : "#dc2626")};
  text-align: right;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const MainLayout = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const ChartSection = styled.div`
  flex: 2;
  min-width: 0;
`;

export const SidebarSection = styled.div`
  flex: 1;
  min-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 1024px) {
    min-width: 100%;
  }
`;

export const PlaceholderCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e5e7eb;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const PlaceholderTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
`;

export const PlaceholderText = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`;

export const TableSection = styled.div`
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  overflow: hidden;
`;

export const TableTitle = styled.h3`
  font-family: "Geist", sans-serif;
  font-size: 16px;
  padding: 24px;
  font-weight: 500;
  color: #181d27;
  line-height: 24px;
`;
